import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import Checkbox from '@material-ui/core/Checkbox'
import TextField from '@material-ui/core/TextField'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import { addTestAutomationClassName } from 'utils/misc'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import InputAdornment from '@material-ui/core/InputAdornment'
import VisibilityOff from '@material-ui/icons/VisibilityOff'

import SubmitButton from 'components/atoms/buttons/SubmitButton'
import { FORM_ACTION_ERROR_STATUS } from 'constants/form'

export const styles = theme => ({
  root: {
    textAlign: 'center',
    padding: `0 ${theme.spacing(1)}px`,
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  formControl: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  footerLink: {
    marginTop: theme.spacing(3),
  },
  submitButton: {
    marginTop: theme.spacing(2),
  },
})

const LoginForm = ({
  errors,
  values,
  status,
  classes,
  rememberMe,
  showActions,
  errorMessage,
  showPassword,
  isSubmitting,
  hasFieldError,
  handleFormSubmit,
  handleFieldChange,
  handleCheckboxChange,
  togglePasswordVisibility,
  className: classNameProp,
}) => {
  const className = classNames(classes.root, classNameProp)
  return (
    <div className={className}>
      {status === FORM_ACTION_ERROR_STATUS && errorMessage ? (
        <Typography
          className={classes.errorMessage}
          color="error"
          align="center">
          {errorMessage}
        </Typography>
      ) : null}
      <form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('email')}>
          <TextField
            id="email"
            name="email"
            label="Email Address"
            value={values.email}
            onChange={handleFieldChange}
            margin="normal"
            error={hasFieldError('email')}
            inputProps={{
              maxLength: 256,
            }}
            className={addTestAutomationClassName('qa-signin-field-email')}
          />
          {hasFieldError('email') ? (
            <FormHelperText>{errors.email}</FormHelperText>
          ) : null}
        </FormControl>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('password')}>
          <TextField
            id="password-input"
            name="password"
            label="Password"
            value={values.password}
            onChange={handleFieldChange}
            type={showPassword ? 'text' : 'password'}
            autoComplete="password"
            error={hasFieldError('password')}
            margin="normal"
            InputProps={{
              maxLength: 1024,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Toggle password visibility"
                    onClick={togglePasswordVisibility}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            className={addTestAutomationClassName('qa-signin-field-password')}
          />
          {hasFieldError('password') ? (
            <FormHelperText>{errors.password}</FormHelperText>
          ) : null}
        </FormControl>
        {/*
        <FormControl className={classes.formControl} fullWidth>
          <FormControlLabel
            control={
              <Checkbox
                checked={rememberMe}
                onChange={handleCheckboxChange}
                value="rememberMe"
                color="primary"
              />
            }
            label="Remember me"
            className={addTestAutomationClassName('qa-signin-checkbox-rememberme')}
          />
        </FormControl>
        */}
        <FormControl className={classes.formControl} fullWidth>
          <SubmitButton
            size="large"
            type="submit"
            color="primary"
            variant="primary"
            disabled={isSubmitting}
            className={classNames(
              classes.submitButton,
              addTestAutomationClassName('qa-signin-button-signin')
            )}>
            Sign in
          </SubmitButton>
        </FormControl>
        {showActions && (
          <React.Fragment>
            <FormControl
              className={classNames(classes.formControl, classes.footerLink)}
              fullWidth>
              <Typography>
                <Link
                  href="/reset"
                  className={addTestAutomationClassName('qa-signin-link-forgotpassword')}>
                  Forgot password?
                </Link>
              </Typography>
            </FormControl>
            <FormControl
              className={classNames(classes.formControl, classes.footerLink)}
              fullWidth>
              <Typography>
                <Link
                  href="/create-account"
                  className={addTestAutomationClassName('qa-signin-link-createaccount')}>
                  Create an account
                </Link>
              </Typography>
            </FormControl>
          </React.Fragment>
        )}
      </form>
    </div>
  )
}

LoginForm.propTypes = {
  showActions: PropTypes.bool,
  apiCallError: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  togglePasswordVisibility: PropTypes.func,
  className: PropTypes.string,
  errorMessage: PropTypes.string,
  errors: PropTypes.object,
  showPassword: PropTypes.bool,
  handleCheckboxChange: PropTypes.func,
  handleFieldChange: PropTypes.func,
  hasFieldError: PropTypes.func,
  handleFormSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  rememberMe: PropTypes.bool,
  onLogin: PropTypes.func,
  status: PropTypes.string,
  values: PropTypes.object,
}

LoginForm.defaultProps = {}

export default withStyles(styles)(LoginForm)



// WEBPACK FOOTER //
// ./src/components/organisms/LoginForm/LoginForm.js